import { Controller } from "stimulus";
import { EventScroll } from "../events";
import { debounce } from "../util";

const initializeScroll = () => {
  window.addEventListener(
    "scroll",
    debounce(() => {
      // when scroll happen
      window.dispatchEvent(
        new CustomEvent(EventScroll, {
          bubble: true
        })
      );
    }),
    100
  );
  return true;
};

let cgscroll;

// A mini-controller to load widget dynamically
// Used in Widgets coin tab.
export default class extends Controller {
  isLoad = false;

  connect() {
    const widgetName = this.data.get("widget-name");

    if (window.customElements && !window.customElements.get(widgetName)) {
      // check whether scroll initialize or not
      if (!cgscroll) {
        cgscroll = initializeScroll();
      }
      // init
      this._checkAndLoadWidget(widgetName);
      // listen to scroll event
      window.addEventListener(EventScroll, e => {
        if (this.isLoad) {
          window.removeEventListener(EventScroll, () => {});
        } else {
          this._checkAndLoadWidget(widgetName);
        }
      });
    }
  }

  _checkAndLoadWidget(widgetName) {
    const { top } = this.element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const topHeightElement = top + scrollTop;
    const shouldLoad =
      document.documentElement.scrollTop + document.documentElement.clientHeight > topHeightElement;
    if (shouldLoad) {
      loadScript(`https://widgets.coingecko.com/${widgetName}.js`);
      this.isLoad = true;
    }
  }
}
